/* unplugin-vue-components disabled */import { ElRadioGroup as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/radio-group/style/css';
import { ElRadioButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/radio-button/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0afe757a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "real-name-container"
};
const _hoisted_2 = {
  class: "tab flex justify-between marginT10"
};
const _hoisted_3 = {
  class: "content-container"
};
import { useAppStore } from '@/store/modules/app';
import ParamsRealName from './paramsRealName.vue';
import ChannelRealName from './channelRealName.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'realName',
  setup(__props) {
    const currentTab = ref('params');
    const useApp = useAppStore();
    const gameInfo = computed(() => useApp.gameInfo);
    return (_ctx, _cache) => {
      const _component_el_radio_button = __unplugin_components_0;
      const _component_el_radio_group = __unplugin_components_1;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_radio_group, {
        modelValue: _unref(currentTab),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(currentTab) ? currentTab.value = $event : null)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio_button, {
          label: "params"
        }, {
          default: _withCtx(() => [_createTextVNode("实名参数")]),
          _: 1
        }), _createVNode(_component_el_radio_button, {
          label: "channel"
        }, {
          default: _withCtx(() => [_createTextVNode("渠道实名")]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_3, [_unref(currentTab) === 'params' ? (_openBlock(), _createBlock(ParamsRealName, {
        key: 0,
        gameInfo: _unref(gameInfo)
      }, null, 8, ["gameInfo"])) : (_openBlock(), _createBlock(ChannelRealName, {
        key: 1,
        gameInfo: _unref(gameInfo)
      }, null, 8, ["gameInfo"]))])]);
    };
  }
});